import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateUtil } from 'app/core/utils/DateUtil';
import { TraceServiceImprovement } from 'app/trace-management/core/services/trace-improvement.service';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'biz-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent {
  public selectedCategory: string;
  public selectedSource: string;
  public fileNameFilter: string;
  public showMessage: boolean = false;
  public disabledCreationDate: boolean = true;
  public disabledModificationDate: boolean = false;

  public dateMinCreation: Date = new Date();
  public dateMaxCreation: Date = new Date();
  public dateMinModified: Date = new Date();
  public dateMaxModified: Date = new Date();

  public sources: Array<string> = [];
  public categories: Array<string> = [];

  public isCollapsed: boolean = false;

  @Input() showLoading: boolean = false;

  @Output() emitFilter: EventEmitter<ITraceFilterManagement> = new EventEmitter<ITraceFilterManagement>();
  @Output() emitIsCollapse: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private _traceService: TraceServiceImprovement, private _i18nService: I18nService) {
    this.setDateToMidnight(this.dateMinCreation, true);
    this.setDateToMidnight(this.dateMaxCreation, false);
    this.setDateToMidnight(this.dateMinModified, true);
    this.setDateToMidnight(this.dateMaxModified, false);
  }

  ngOnInit() {
    this._traceService.getCategories().subscribe((data: any) => {
      this.sources = data.Applications;
      this.selectedSource = 'All'; // TODO: While is defined the correlation between sources and categories
      this.upperCategories(data.Categories);
    });
  }

  setDateToMidnight(date: Date, zeroHour): void {
    if (zeroHour)
      date.setHours(0, 0, 0, 0);
    else
      date.setHours(23, 59, 59, 999);
  }

  upperCategories(categories) {
    this.categories = categories.map(category => {
      if (category.toLowerCase() === 'ecm') return 'ECM';
      if (category.toLowerCase() === 'rpa') return 'RPA';
      return category;
    });
    this.selectedCategory = 'All';
  }

  filterFileTraces(event, option) {
    if (option === 0) {
      this.dateMinCreation = event.start;
      this.dateMaxCreation = event.end;
    } else {
      this.dateMinModified = event.start;
      this.dateMaxModified = event.end;
    }
  }

  getFilesNames() {
    this.trimFilterName();
    let traceFilter: ITraceFilterManagement = {
      Category: this.fixCategory(),
      Application: this.selectedSource,
      FileName: this.fileNameFilter,
      Created_From: this.formatDateToCustomString(DateUtil.returnDateToSave(this.dateMinCreation)),
      Created_To: this.formatDateToCustomString(DateUtil.returnDateToSave(this.dateMaxCreation)),
      Modified_From: this.formatDateToCustomString(DateUtil.returnDateToSave(this.dateMinModified)),
      Modified_To: this.formatDateToCustomString(DateUtil.returnDateToSave(this.dateMaxModified))
    }

    if (this.disabledModificationDate) {
      traceFilter.Modified_From = null;
      traceFilter.Modified_To = null;
    }

    if (this.disabledCreationDate) {
      traceFilter.Created_From = null;
      traceFilter.Created_To = null;
    }

    this.emitFilter.emit(traceFilter);
  }

  formatDateToCustomString(dateString: string): string {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(5, 7);
    const day = dateString.substring(8, 10);
    const hours = dateString.substring(11, 13);
    const minutes = dateString.substring(14, 16);

    return `${year}${month}${day}${hours}${minutes}`;
  }

  fixCategory() {
    let categoryToSend = this.selectedCategory;
    if (categoryToSend === 'ECM')
      categoryToSend = 'Ecm';
    if (categoryToSend === 'RPA')
      categoryToSend = 'Rpa';
    return categoryToSend;
  }

  trimFilterName() {
    if (this.fileNameFilter && this.fileNameFilter.length > 0)
      this.fileNameFilter = this.fileNameFilter.trim();
    return this.fileNameFilter;
  }

  disabledButton() {
    let desibledBtn = true;
    if (this.selectedCategory && this.selectedSource)
      desibledBtn = false;
    if (this.validateDates(true))
      desibledBtn = true;
    if (this.validateDates(false))
      desibledBtn = true;
    return desibledBtn || this.showLoading;
  }

  validateDates(option) {
    if (option)
      return this.dateMinCreation > this.dateMaxCreation && this.disabledCreationDate;
    else
      return this.dateMinModified > this.dateMaxModified && this.disabledModificationDate;
  }

  collapse() {
    this.isCollapsed = !this.isCollapsed;
    this.emitIsCollapse.emit(this.isCollapsed);
  }
}
